export default __webpack_public_path__ + "static/media/Image-4.d116bf34.png";